import { Autocomplete, Box, DialogContentText, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { updateFormValues, updateSelectedReportId } from '../../../redux/slices/reports';
import SimpleAutocompleteProps from '../../../reusable-components/autocomplete/SimpleAutocompleteProps';
import Iconify from '../../../reusable-components/iconify';

export default function ReportSelectTypeStep() {
  const dispatch = useDispatch();
  const { formValues, createReportData } = useSelector(state => state.reports.data);
  const reportsList = createReportData?.reports ?? [];
  const reportTypesList = createReportData?.reportTypes ?? [];

  return <>
    <DialogTitle sx={{ textAlign: 'center', color: 'rgba(112, 112, 112, 0.5)' }}>Choose Report</DialogTitle>
    <DialogContentText sx={{ fontWeight: 'bold' }}>Choose Report Type:</DialogContentText>
    <Autocomplete
      {...SimpleAutocompleteProps}
      sx={{ mt: 1 }}
      options={reportTypesList || []}
      autoHighlight
      value={formValues.selectedReportType || null}
      onChange={(event, newValue) =>
        dispatch(updateFormValues({ ...formValues, selectedReportType: newValue, selectedReport: null, downloadAsCsv: false }))
      }
    />
    <DialogContentText sx={{ fontWeight: 'bold', mt: 2 }}>Choose Report:</DialogContentText>
    <Autocomplete
      {...SimpleAutocompleteProps}
      sx={{ mt: 1 }}
      options={
        formValues.selectedReportType ? reportsList?.filter((x) => x.typeId === formValues.selectedReportType.id) : []
      }
      value={formValues.selectedReport || null}
      onChange={(event, newValue) => {
        dispatch(updateFormValues({ ...formValues, selectedReport: newValue, timeFrame: null, downloadAsCsv: false }));
        dispatch(updateSelectedReportId(newValue?.id ?? 0));
      }}
      renderOption={(props, option) => (
        <Box component="li" sx={{ display: 'flex', alignItems: 'center' }} {...props}>
          {option.label}
          <Tooltip title={option.description}>
            <IconButton>
              <Iconify icon={'eva:eye-outline'} />
            </IconButton>
          </Tooltip>
          {option.isEmailedReport && (
            <Tooltip title={'Report will be sent to your email'}>
              <IconButton>
                <Iconify icon={'ic:outline-email'} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      )}
    />
  </>;
}
